import { InputAdornment } from '@mui/material';
import RHFTextareaField from 'src/components/hook-form/RHFTextareaField';
import AcceptOrRejectWithQuestionsWithReason from '../AcceptOrRejectWithQuestionsWithReason';

const FormInputText = ({ name, data, disabled, index, ...props }) => {
  return (
    <RHFTextareaField
      name={name}
      label={data?.label}
      disabled={disabled}
      InputProps={{
        autoComplete: 'off',
        ...(data?.need_confirm // && isHistory
          ? {
              endAdornment: (
                <InputAdornment
                  position="start"
                  sx={{
                    display: 'flex',
                    gap: 1,
                  }}
                >
                  <AcceptOrRejectWithQuestionsWithReason
                    {...data?.client_inputs?.[index || 0]}
                    history={data?.old_client_inputs?.[index || 0]}
                    type={data?.type}
                  />
                </InputAdornment>
              ),
            }
          : {}),
      }}
      {...props}
      {...data?.options?.inputProps}
    />
  );
};

export default FormInputText;
